// extracted by mini-css-extract-plugin
module.exports = {"reg":"z9-T_r0kNqkOw1Kna1ilX"};